import React from 'react';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
} from '@headlessui/react';
import { actionPrimaryButtonClassName } from '@core/theme/actionTheme.util';

interface ExemptionConfirmModalProps {
  isOpen: boolean;
  isUndo: boolean;
  isUpdating: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ExemptionConfirmModal = ({
  isOpen,
  isUndo,
  isUpdating,
  onClose,
  onConfirm,
}: ExemptionConfirmModalProps) => {
  return (
    <Transition show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-[60]"
        onClose={() => !isUpdating && onClose()}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
            >
              <DialogPanel className="flex max-w-md flex-col rounded-xl bg-white shadow-xl transition-all">
                <div className="border-b border-gray-200 px-4 py-3">
                  <DialogTitle
                    as="h3"
                    className="text-lg font-medium text-gray-900"
                  >
                    {isUndo
                      ? 'Do you want to undo this exemption?'
                      : 'Do you want to exempt this job?'}
                  </DialogTitle>
                </div>
                <div className="px-4 py-4">
                  <p className="text-sm text-gray-700">
                    {isUndo
                      ? "This job will count against the candidate's reliability rating again."
                      : "This job will no longer count against the candidate's reliability rating."}
                  </p>
                </div>
                <div className="flex justify-end gap-2 border-t border-gray-200 px-4 py-3">
                  <button
                    type="button"
                    disabled={isUpdating}
                    onClick={onClose}
                    className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={isUpdating}
                    onClick={onConfirm}
                    className={`rounded-md px-4 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 ${actionPrimaryButtonClassName}`}
                  >
                    {isUpdating
                      ? 'Updating...'
                      : isUndo
                        ? 'Undo Exemption'
                        : 'Exempt Job'}
                  </button>
                </div>
              </DialogPanel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ExemptionConfirmModal;
